import { CORE_SERVICE_URLS } from '~/Constants/Urls.constants';
import { routeReplacer } from '~/Helpers/String.helper';
import { useOrganisation, useRequest, useUUID } from '~/Hooks';
import { useState } from 'react';
import { IErrorResponse } from '~/Models/DTO/Error.models';

interface IImageResponse {
  url: string;
}

export const useImage = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState<IErrorResponse>({});
  const [uploadedImage, setUploadedImage] = useState<string>();

  const { organisation } = useOrganisation();
  const { requestWithCallback } = useRequest();
  const { createUUID } = useUUID();
  const requestUploadImage = async (imageData: string) => {
    await requestWithCallback<IImageResponse>(
      {
        url: routeReplacer(CORE_SERVICE_URLS.UPLOAD_IMAGE, {
          domain: organisation?.domain || '',
        }),
        method: 'POST',
        data: { imageData, name: createUUID() },
      },
      (data) => {
        setIsLoading(false);
        setUploadedImage(data.url);
      },
      (error) => {
        setIsLoading(false);
        setHasError(error);
      },
    );
  };

  return {
    uploadedImage,
    requestUploadImage,
    isLoading,
    hasError,
  };
};
